// extracted by mini-css-extract-plugin
module.exports = {"header":"order-history_header__VA26Q","ordersListWrapper":"order-history_ordersListWrapper__sRQIy"};